import React from 'react';
import firebase from 'firebase';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Card, Button } from "@material-ui/core/";

import { rejectPolicy, approvePolicy } from '../db';

const dateFormat = require("dateformat");

const useStyles = makeStyles((theme) => ({
    container: {
    },
    buttonRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
    },
    datalabelcontainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: "15px",
        alignItems: "flex-start"
    },
    currentPolicyContainer: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start"
    },
    policycard: {
        border: "1px solid #e3e3e3",
        padding: "15px",
        margin: "13px 0"
    },
    submissionsContainer: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    },
    subContainer: {
        display: "flex",
        flexDirection: "column",
        borderTop: "1px solid #e3e3e3",
        marginTop: "20px"
    },
    subDataRow: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap"
    }
}))

export default function PolicyReviewCard({ policy, triggerRefresh }) {
    const classes = useStyles();

    const handleAcceptPolicy = async (submission) => {
        approvePolicy(submission)
        triggerRefresh();
    }

    const handleRejectPolicy = async (submission) => {
        await rejectPolicy(submission);
        triggerRefresh();
    }

    const renderCurrentData = () => {
        if (policy.data) {
            
            return (
                <>
                    <h4>Current Policy:</h4>
                    <div className={classes.currentPolicyContainer}>
                        {Object.keys(policy.data).map(key => {
                            if (typeof key === 'Date') return null;
                            return <DataLabel label={key} data={policy.data[key]} />
                        })}
                    </div>                
                </>

            )
        }
        return <h4>Current Policy: none</h4>;
    }

    const getSubmissionRow = (sub) => {
        return Object.keys(sub).map(key => {
            if (typeof key === 'Date') return null;
            return <DataLabel label={key} data={sub[key]} />
        })        
    }

    // To Accept:
    // 1. See if policy exists for current company
    //  1a. if it exists, grab data ; and add to "previousState" field
    //  1b. once added to previous state field, take new policy and update company
    // 2. Mark current submission as "verified"

    // To Reject:
    // 1. Mark current submission as verified / deleted 

    // At the end of both of these actions, trigger an update function 

    return (
        <Card className={classes.policycard}>
            <Typography variant="h5">{`${policy.id}`}</Typography>
            <hr />
            <div style={{ padding: "0 20px" }}>
                {renderCurrentData()}
                <div className={classes.submissionsContainer}>
                    {policy.submissions.map(sub => {
                        return (
                            <div className={classes.subContainer}>
                                <h4>New Submission:</h4>
                                <div className={classes.subDataRow}>
                                    {getSubmissionRow(sub)}
                                </div>
                                <div className={classes.buttonRow}>
                                    <Button variant="contained" color="primary" onClick={() => handleAcceptPolicy(sub)} style={{ marginRight: "15px" }}>Accept Policy</Button>
                                    <Button variant="contained" color="primary" onClick={() => handleRejectPolicy(sub)}>Reject Policy</Button>
                                </div>
                            </div>
                        )
                        
                    })}
                </div>
            </div>
        </Card>
    )
}

function DataLabel({ label, data }) {
    const classes = useStyles();

    let dataText = "";
    let labelText = label;

    if (label === "remoteUntil" || label === "remoteSince" || label === "submissionDate") {
        dataText = `${dateFormat(
            data.toDate())}`
    } else if (data === true || data === false){
        dataText = `${data}`
    } else {
        dataText = data;
    }

    if (label === "source") {
        return (
            <div className={classes.datalabelcontainer}>
                <Typography style={{ fontWeight: "bold" }}>{labelText}</Typography>
                <Typography><a className={classes.source} href={dataText} rel="noopener noreferrer" target="_blank">{dataText.substring(10, 20)}</a></Typography>
            </div>
        )
    }
    

    return (
        <div className={classes.datalabelcontainer}>
            <Typography style={{ fontWeight: "bold" }}>{labelText}</Typography>
            <Typography>{dataText}</Typography>
        </div>
    )
}